export type BlogType = {
  id: number | string;
  thumb: string;
  date: string;
  title: string;
  description: string;
  tag: string[];
  content: string;
};
export const blogs: BlogType[] = [{
  id: '1',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '2',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '3',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '4',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '5',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '6',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '7',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '8',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '9',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '10',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '11',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '12',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '13',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '14',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '15',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '16',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '17',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}, {
  id: '18',
  thumb: '/assets/blog/blog-img.png',
  date: 'nov 10, 2024',
  title: 'Lorem ipsum dolor sit',
  description: 'Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.',
  tag: ['casino', 'crypto', 'news'],
  content: ''
}];